<template>
  <div class="rBox">
    <div class="pageTitle">{{ fySelItem.title }}页面</div>

    <el-form label-width="90px">
      <div>
        <el-card>
          <div
            v-for="(item, index) in curSelData.zsxx.picList"
            :key="index"
            class="box-card"
            style="margin-top: 10px"
          >
            <div slot="header" class="clearfix">
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click="delLunboItem(index)"
                >删除</el-button
              >
            </div>
            <el-form-item label="证书图片">
              <el-col :span="18">
                <el-input v-model="item.url" placeholder="请输入内容图片地址">
                  <template slot="append"
                    ><span
                      style="cursor: pointer"
                      @click="selImg('chenwu', 'picList', index)"
                      >选择图片</span
                    ></template
                  >
                </el-input>
              </el-col>
              <el-col :span="18">
                <img height="100px" :src="item.url" alt="" class="imgClass" />
              </el-col>
            </el-form-item>
          </div>
          <el-button
            style="margin: 20px auto; width: 80%; display: block"
            @click="addLunboItem(index)"
            >添加证书</el-button
          >
        </el-card>
      </div>
      <div class="pageTitle pageTitle2">电话配置</div>
      <el-form-item label="电话号码">
        <el-input v-model="curSelData.zsxx.phone" placeholder="请输入电话号码">
        </el-input>
      </el-form-item>
      <!-- 验证码开始 -->
      <div class="pageTitle pageTitle2">防伪二维码</div>
       <el-form-item label="二维码大小">
				<template>
					<bs-slider v-model="curSelData.scanSize" :min="0" :max="100" />
				</template>
			</el-form-item>
			<el-form-item label="二维码上下边距">
				<template>
					<bs-slider v-model="curSelData.marginTop" :min="0" :max="100" />
				</template>
			</el-form-item>
			<el-form-item label="二维左右边距">
				<template>
					<bs-slider v-model="curSelData.marginLeft" :min="0" :max="100" />
				</template>
			</el-form-item>
      <el-form-item label="二维码背景">
        <el-input v-model="curSelData.scanBg" placeholder="请输入图片地址">
          <template slot="append"
            ><span style="cursor: pointer" @click="selImg('chenwu', 'scanBg')"
              >选择图片</span
            ></template
          >
        </el-input>
      </el-form-item>
      <el-form-item label="背景图片">
        <el-input v-model="curSelData.boxBg" placeholder="请输入图片地址">
          <template slot="append"
            ><span style="cursor: pointer" @click="selImg('chenwu', 'boxBg')"
              >选择图片</span
            ></template
          >
        </el-input>
        <el-col :span="18">
          <img :src="curSelData.boxBg" alt="" class="imgClass" />
        </el-col>
      </el-form-item>
      <el-form-item label="跳转控件">
        <template>
          <el-radio v-model="curSelData.zsxx.jumpStyle" :label="1"
            >显示</el-radio
          >
          <el-radio v-model="curSelData.zsxx.jumpStyle" :label="2"
            >不显示</el-radio
          >
        </template>
      </el-form-item>
      <!-- 验证码结束 -->

      <div class="pageTitle pageTitle2">溯源可视化视频</div>
      <el-card class="box-card" style="margin-top: 10px">
        <div slot="header" class="clearfix">视频</div>
        <div v-for="(item, index) in curSelData.zsxx.videoList" :key="index">
          <div class="flexEnd">
            <el-button type="danger" class="delVideo" @click="delVideo(index)"
              >删除视频</el-button
            >
          </div>
          <el-form-item label="视频时间" style="margin-top: 20px">
            <el-input
              v-model="item.time"
              type="text"
              placeholder="请输入视频时间"
            />
          </el-form-item>
          <el-form-item label="视频内容">
            <el-input
              v-model="item.desc"
              type="text"
              placeholder="请输入视频内容"
            />
          </el-form-item>
          <el-row>
            <el-col>
              <el-input v-model="item.url" placeholder="请输入视频链接">
                <template slot="append"
                  ><span style="cursor: pointer" @click="selVideo(index)"
                    >选择视频</span
                  ></template
                >
              </el-input>
            </el-col>
          </el-row>
          <el-row style="margin-top: 10px">
            <el-input v-model="item.poster" placeholder="请输入视频封面">
              <template slot="append"
                ><span
                  style="cursor: pointer"
                  @click="selImg('chenwu', 'videoPoster', index)"
                  >选择封面</span
                ></template
              >
            </el-input>
            <el-col :span="18">
              <img height="100px" :src="item.poster" alt="" class="imgClass" />
            </el-col>
          </el-row>
        </div>
        <div class="flexCenter">
          <el-button
            style="margin: 20px auto; width: 80%; display: block"
            @click="addVideo(index)"
            >添加视频</el-button
          >
        </div>
      </el-card>
    </el-form>
    <div class="pageTitle pageTitle2">证书“背后的故事”页面</div>
    <el-form label-width="100px">
      <el-form-item label="展示照片">
        <el-radio-group v-model="curSelData.showPhotos">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="2">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <div></div>
      <div v-if="curSelData.showPhotos === 1">
        <el-form-item label="logo">
          <el-col :span="18">
            <el-input
              v-model="curSelData.xchy.logo"
              placeholder="请输入logo地址"
            >
              <template slot="append"
                ><span style="cursor: pointer" @click="selImg('chenwu', 'logo')"
                  >选择图片</span
                ></template
              >
            </el-input>
          </el-col>
          <el-col :span="18">
            <img
              height="100px"
              :src="curSelData.xchy.logo"
              alt=""
              class="imgClass"
            />
          </el-col>
        </el-form-item>
        <el-form-item label="标题">
          <el-input
            v-model="curSelData.xchy.title"
            type="text"
            placeholder="请输入标题"
          />
        </el-form-item>

        <el-card class="box-card" style="margin-top: 10px">
          <div slot="header" class="clearfix">视频</div>
          <el-form-item label="标题" style="margin-top: 20px">
            <el-input
              v-model="curSelData.xchy.infoTit"
              type="text"
              placeholder="请输入标题"
            />
          </el-form-item>
          <el-form-item label="英文标题">
            <el-input
              v-model="curSelData.xchy.infoEng"
              type="text"
              placeholder="请输入英文标题"
            />
          </el-form-item>
          <el-row>
            <el-col>
              <el-input
                v-model="curSelData.xchy.video"
                placeholder="请输入视频链接"
              >
                <template slot="append"
                  ><span style="cursor: pointer" @click="selVideo"
                    >选择视频</span
                  ></template
                >
              </el-input>
            </el-col>
          </el-row>
          <el-row style="margin-top: 10px">
            <el-input
              v-model="curSelData.xchy.poster"
              placeholder="请输入图片地址"
            >
              <template slot="append"
                ><span
                  style="cursor: pointer"
                  @click="selImg('chenwu', 'poster')"
                  >选择封面</span
                ></template
              >
            </el-input>
            <el-col :span="18">
              <img
                height="100px"
                :src="curSelData.xchy.poster"
                alt=""
                class="imgClass"
              />
            </el-col>
          </el-row>
        </el-card>
        <div></div>
      </div>
    </el-form>
  </div>
</template>
<script>
import BsSlider from "../module/BsSlider";
import BsColorPicker from "../module/BsColorPicker";
export default {
  components: {
    BsSlider
  },
  props: {
    curSelData: {
      type: Object,
      default: () => {
        tabbar;
      },
    },
    fySelItem: {},
  },
  computed: {
    selIndex() {
      let index = 0;
      for (let i = 0; i < this.curSelData.tabbar.length; i++) {
        if (this.curSelData.tabbar[i].title === this.fySelItem.title) {
          index = i;
        }
      }
      return index;
    },
  },
  data() {
    return {};
  },
  methods: {
    addVideo() {
      this.curSelData.zsxx.videoList.push({
        time: "",
        desc: "",
        poster: "",
        video: "",
      });
    },
    delVideo(index) {
      this.curSelData.zsxx.videoList.splice(index, 1);
    },
    clearColor(attr) {
      this.curSelData[attr] = "transparent";
    },
    addItem() {
      const width = (100 / (this.curSelData.picList.length + 1)).toFixed(2);
      this.curSelData.picList.forEach((item) => {
        item.width = width + "%";
      });
      this.curSelData.picList.push({ width: width + "%", url: "" });
    },
    delPic(index) {
      const width = (100 / (this.curSelData.picList.length - 1)).toFixed(2);
      this.curSelData.picList.forEach((item) => {
        item.width = width + "%";
      });
      this.curSelData.picList.splice(index, 1);
    },

    // 选择图片
    selImg(type, attr, index) {
      this.$emit("selImg", type, attr, index);
    },
    // 选择视频
    selVideo(index) {
      this.$emit("selVideo", "mulVideo", 'videoList', index);
    },
    // 证书信息
    delSItem(index, sIndex) {
      this.curSelData.zsxx.infoMain[index].siteList.splice(sIndex, 1);
    },
    addSItem(index, sIndex) {
      this.curSelData.zsxx.infoMain[index].siteList.push({
        siteInfo: [
          {
            name: "",
            value: "",
          },
        ],
      });
    },
    delSSItem(index, sIndex, ssIndex) {
      this.curSelData.zsxx.infoMain[index].siteList[sIndex].siteInfo.splice(
        ssIndex,
        1
      );
    },
    addSSItem(index, sIndex) {
      this.curSelData.zsxx.infoMain[index].siteList[sIndex].siteInfo.push({
        name: "",
        value: "",
      });
    },
    addInfoMainOne() {
      this.curSelData.zsxx.infoMain.push({
        title: "·标题",
        msg: "内容",
        msgColor: "#1C3B9E",
        linkImg:
          "https://apkpic.86122m.com/mktpic/fangyuan/rk1.png",
        linkHref: "",
        type: 1,
        siteList: [
          {
            siteInfo: [
              {
                name: "名称",
                value: "内容",
              },
            ],
          },
        ],
      });
    },
    delInfoMainOne(index) {
      this.curSelData.zsxx.infoMain.splice(index, 1);
    },
    addLunboItem(index) {
      this.curSelData.zsxx.picList.push({
        url: "https://apkpic.86122m.com/mktpic/fangyuan/zsTest.png",
      });
    },
    delLunboItem(index) {
      this.curSelData.zsxx.picList.splice(index, 1);
    },
    addInfoMain2One(index) {
      this.curSelData.zsxx.infoMain2.push({
        box1: {
          title: "标题1",
          msg: "内容1",
          msgColor: "#2E3033",
        },
        box2: {
          title: "标题2",
          msg: "内容2",
          msgColor: "#2E3033",
        },
      });
    },
    delInfoMain2One(index) {
      this.curSelData.zsxx.infoMain2.splice(index, 1);
    },
    addPhotoItem() {
      this.curSelData.xchy.photoList.push({
        url: "",
      });
    },
    delPhotoItem(index) {
      this.curSelData.xchy.photoList.splice(index, 1);
    },
    addTx() {
      this.curSelData.txjs.listData.push({
        name: "标题",
        nameEng: "英文标题",
        numImg:
          "https://apkpic.86122m.com/mktpic/fangyuan/number01.png",
        type: 1,
        content: "内容",
      });
    },
    delTx(index) {
      this.curSelData.txjs.listData.splice(index, 1);
    },
    addGy() {
      this.curSelData.gyfy.listData.push({
        name: "标题",
        nameEng: "英文标题",
        type: 1,
        content: "内容",
      });
    },
    delGy(index) {
      this.curSelData.gyfy.listData.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.imgClass {
  margin-top: 10px;
}

.pageTitle {
  color: #20a0ff;
  font-weight: bold;
  text-align: center;
  padding: 10px 0;
}

.pageTitle2 {
  border-top: 1px solid #20a0ff;
}
.imgClass {
  width: 200px;
  height: auto;
  margin: 15px 0;
}
.flexEnd {
  display: flex;
  justify-content: flex-end;
}
</style>
